export class SalePriceScheduleType {
  id: number;
  name: string;
  sequence: number;

  constructor() { }

  static arrayFromJSON(json: string): SalePriceScheduleType[] {
    const values = JSON.parse(json);
    if (!values || !Array.isArray(values)) {
      return null;
    }

    const result: SalePriceScheduleType[] = [];
    for (const item of values) {
      result.push(SalePriceScheduleType.createFromAny(item));
    }

    return result;
  }

  static createFromAny(object: any): SalePriceScheduleType {
    if (object === null || object === undefined) {
      return null;
    }
    const salePriceScheduleType = new SalePriceScheduleType();
    salePriceScheduleType.id = object.id;
    salePriceScheduleType.name = object.name;
    salePriceScheduleType.sequence = object.sequence;

    return salePriceScheduleType;
  }

  toJSON(): any {
    return {
      id: this.id,
      name: this.name,
      sequence: this.sequence
    };
  }
}
